/**
 * useWeekStartsOn — the organization's first day of the week (#864).
 *
 * Every week the screens draw (the Week period, its arrows, its label, "is
 * this the current week") starts on this day, and every one of them gets it
 * from here rather than deciding for itself. Monday until the value is known,
 * and for an organization that never chose — the week every existing org
 * already had.
 *
 * The value rides on the organization context every member already loads —
 * the `/users/me` roster in the web app, the session in the Bitrix24 iframe —
 * and reaches here through the unified auth context. Not from
 * `GET /api/v1/settings`: that endpoint is client/admin only, so an agent's or
 * a supervisor's dashboard would sit on Monday while the server cut their
 * weekly series on the configured day. A save on the settings screen
 * refreshes the roster, so the dashboards' weeks move without a reload.
 *
 * Through `useOptionalAuth`, not `useRole`: the dashboards also run inside
 * the Bitrix24 iframe, where there is no Clerk, and the unified context is
 * what serves both (`UnifiedAuthContext`).
 */

import { DEFAULT_WEEK_STARTS_ON, type WeekStartsOn } from '@aica/core';
import { useOptionalAuth } from '@/contexts/unified-auth-context-object';

export function useWeekStartsOn(): WeekStartsOn {
  return useOptionalAuth()?.weekStartsOn ?? DEFAULT_WEEK_STARTS_ON;
}
